/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import MainHeader from "../../../../Shared/components/Header";
import { ProductGstCodeTable } from "./ProductGstCodeTable";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const ProductGstCode = (props) => {
    const { productGstdetails, loader } = useSelector(state => state.adminSetupReducer);
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);

    const [visible, setVisible] = useState(false);
    const [gstCode, setGstCode] = useState('');
    const [description, setDescription] = useState('');
    const [percentage, setPercentage] = useState('');
    const [addMore, setAddMore] = useState(false);
    const [errorGst, setErrorGst] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [errorPercentage, setErrorPercentage] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    };
    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const dispatch = useDispatch();


    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Product GST Code', history, 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ code: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ percentage: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'productgst',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    const emptyState = () => {
        setErrorGst(false);
        setErrorPercentage(false);
    };

    const emptyStateInput = () => {
        setGstCode('');
        setDescription('');
        setPercentage('');
    };

    const createGst = (e) => {
        e.preventDefault();
        //  let emptyGst = customAlaphaNumericOnlyValidation('Gst Code', gstCode);
        let emptyGst = emptyValidation('Gst Code', gstCode);
        let emptyPercentage = emptyValidation('Percentage', percentage);
        emptyState();
        if (emptyGst.isValid && emptyPercentage.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'productgst',
                title: 'Product Gst',
                details: {
                    code: gstCode,
                    description: description,
                    percentage: parseInt(percentage)
                }
            });
        } else {
            if (emptyGst.errors) {
                setErrorGst(emptyGst.errors);
            }
            if (emptyPercentage.errors) {
                setErrorPercentage(emptyPercentage.errors);
            }
        }
    }
    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message.split("|");
            if (error[0] === 'code') {
                setErrorGst(error[1]);
            }
            if (error[0] === 'percentage') {
                setErrorPercentage(error[1]);
            }
        }
    }, [createDetails, createError]);

    const handleAddMore = (e) => {
        createGst(e);
        setAddMore(true);
    }


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.PRODUCTGST_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'productgst',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Product GST Code', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Product GST Code-Maintenance'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Product GST Code', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                // onChange={(e) => setPassword(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24}  className={clsx(classes.textAlignRight,classes.allCustomerTop)}>
                                <div className={classes.overlFlowResponsiveDesign}>
                                    <Space size={[20, 20]} direction="horizontal" align="center">
                                        {
                                            roleManagement !== '' && checkComponentPermission('Product GST Code', 'Action', 'Export') &&
                                            <NavLink
                                                to="#"
                                                onClick={() => { loadImportExportData('ProductGst'); }}
                                                className={clsx(classes.customLink)}
                                            >
                                                <Image
                                                    src={ExportIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Product GST Code', 'Action', 'Import') &&
                                            <NavLink
                                                to="#"
                                                onClick={() => { setImportVisible(true); }}
                                                className={clsx(classes.customLink)}>
                                                <Image
                                                    src={ImportIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && checkCRUDPermission('Product GST Code', 'create', 'Younote Admin') &&
                                            <NavLink
                                                to={'#'}
                                                onClick={() => handleOpen()}
                                                className={clsx(classes.customLink)}
                                            >
                                                <Image
                                                    src={AddIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Product GST Code</span>
                                            </NavLink>
                                        }
                                        {
                                            roleManagement !== '' && checkComponentPermission('Product GST Code', 'Action', 'Filter') &&
                                            <></>
                                        }
                                    </Space>
                                    </div>
                                </Col>
                            </Row>

                            <ProductGstCodeTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Product GST Code'}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createGst(e)}>
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Product GST Code ", <span key={"Product GST Code"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorGst ? true : false}
                                    helperText={errorGst}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setGstCode(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Description'
                                    variant={'standard'}
                                    className={clsx(classes.margin30t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}

                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Percentage ", <span key={"Percentage"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    type={'number'}
                                    className={clsx(classes.margin30t)}
                                    onWheel={(e) => e.target.blur()}
                                    error={errorPercentage ? true : false}
                                    helperText={errorPercentage}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setPercentage(e.target.value)}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                    >
                                        Save & Close
                                    </Button>
                                    <Button
                                        key="add"
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        onClick={(e) => handleAddMore(e)}
                                    >
                                        Add more
                                    </Button>
                                </Space>
                            </div>
                        </Box>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'ProductGst'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={productGstdetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}
export default ProductGstCode